import React, { useState, useMemo, useEffect } from "react";
// react plugin used to create DropdownMenu for selecting items
import Select, { components } from 'react-select';
import './SelectStudents.css'

const Option = (props) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null} // Handled by react-select's built-in onChange
      />{' '}
      <label>{props.label}</label>
    </components.Option>
  );
};

const SelectStudents = (props) => {
  const [value, setValue] = useState()
  const [options, setOptions] = useState([])
  const group = props.group
  const setGroup = props.setGroup

  const changeHandler = items => {
    setValue(items)
    let students = []
    items?.map(item => { students.push(item.value) })
    group['students'] = students
    setGroup(group)
  }

  useEffect(() => {

    let alternatives = []
    let selected = []

    props.selectOptions?.map((item) => {
      let target = { value: item._id, label: item.name }

      alternatives.push(target)

      //carrega Students selecionados para telas de consulta
      //se for o caso
      if (group?.students?.includes(item._id)) {
        selected.push(target)
      }

    })

    setOptions(alternatives)
    setValue(selected)

  }, [props.selectOptions])

  return (
    <div >
      <Select
        isMulti
        components={{ Option }}
        className="form-control-alternative"
        isDisabled={props.formDisabled}
        options={options}
        value={value}
        id="input-students"
        classNamePrefix="selectStudents"
        onChange={changeHandler}
      />
    </div>
  );

}

export default SelectStudents;
